export const getShortDates = (date: string): string => {
  if (!date) {
    return "";
  }
  return new Date(date)
    .toLocaleDateString(undefined, {
      timeZone: "UTC",
    })
    .toLowerCase()
    .replace(/\b[a-z]/g, (letter) => letter.toUpperCase());
};

export const getPeriodsStatementsDates = (
  date: string,
  locale = undefined
): string => {
  if (!date) {
    return "N/A";
  }
  return new Date(date).toLocaleDateString(locale, {
    day: "2-digit",
    month: "long",
    year: "2-digit",
    timeZone: "UTC",
  });
};

export const getTransactionSource = (
  source: string,
  t: (key: string) => string,
  te: (key: string) => boolean
): string => {
  if (source === "credit_adjustment") {
    return t("CL_TRANSACTIONS.CREDIT_ADJUSTMENT_DESCRIPTION");
  }

  const translationKey = `CL_TRANSACTIONS.${source}`;
  if (te(translationKey)) return t(translationKey);

  return source?.toUpperCase() || "";
};

export const getTransactionType = (
  type: string,
  t: (key: string) => string,
  te: (key: string) => boolean
): string => {
  if (!type) return "";

  const translationKey = `CL_TRANSACTIONS.${type}`;
  if (te(translationKey)) return t(translationKey);

  return type;
};
